﻿<template>
    <div class="srm-swatch srm-swatch-small" :style="{backgroundColor:color}"></div>
</template>
<script>
    import utils from "../utils/units";
    import * as common from "../utils/common";

    import { mapState, mapGetters } from 'vuex';

    export default {
        props: ['value'],
        computed: {
            ...mapState(["currentUser"]),
            ...mapGetters(["isMetric"]),
            color() {
                return utils.srmToHex(this.value);
            }
        }
    }
</script>
<style scoped>
.srm-swatch { display: inline-block; width: 16px; height: 16px; border: 1px solid rgba(0,0,0,.2); border-radius: var(--bs-radius-hairline); float: left; margin-right: 5px; }
</style>
